export default "__VITE_ASSET__3b47f5e1__"